import React from 'react';
import ServerList from '../../components/server/ServerList';

const ServerListPage = () => {
  return (
    <div>
      <ServerList />
    </div>
  );
};

export default ServerListPage;